import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { PLATFORM_ROUTES } from "@/lib/platform";

const CtaSection = () => {
  const { t, language } = useLanguage();

  return (
    <section className="relative overflow-hidden py-16 bg-nexus-gray text-white">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-20 start-1/4 h-64 w-64 rounded-full bg-nexus-teal/20 blur-3xl animate-float-slow" />
        <div className="absolute -bottom-24 end-1/4 h-64 w-64 rounded-full bg-nexus-yellow/15 blur-3xl animate-float-slower" />
      </div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t("ctaSection.title")}</h2>
          <p className="text-gray-300 mb-8 text-lg">
            {t("ctaSection.description")} 
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="group bg-nexus-brand hover:bg-nexus-brand/90 text-white px-8 rounded-md text-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-nexus-brand/40">
              <Link to="/services">
                {t("ctaSection.servicesButton")}
                <ArrowRight className={`ms-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 ${language === "ar" ? "rotate-180" : ""}`} />
              </Link>
            </Button>
            <Button asChild variant="outline" className="group border-2 border-white bg-transparent text-white hover:bg-white/10 hover:text-white px-8 rounded-md text-lg transition-all duration-300 hover:-translate-y-0.5">
              <a href={PLATFORM_ROUTES.signup} target="_blank" rel="noopener noreferrer">
                {t("ctaSection.communityButton")}
                <ArrowRight className={`ms-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 ${language === "ar" ? "rotate-180" : ""}`} />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
